import { createSlice } from "@reduxjs/toolkit";
import {
  fetchVendorrecommendationsItems,
  postVendorrecommendation,
} from "./VendorrecommendationsThunks";

const initialState = {
  items: [],
  loading: false,
  error: null,
};

const vendorrecommendationsSlice = createSlice({
  name: "vendorrecommendations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendorrecommendationsItems.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendorrecommendationsItems.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchVendorrecommendationsItems.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
    // POST
    builder
      .addCase(postVendorrecommendation.pending, (state) => {
        state.postStatus = "loading";
        state.error = null;
      })
      .addCase(postVendorrecommendation.fulfilled, (state, action) => {
        state.postStatus = "succeeded";
        state.items.push(action.payload); // Optional: add new item to state
      })
      .addCase(postVendorrecommendation.rejected, (state, action) => {
        state.postStatus = "failed";
        state.error = action.payload || action.error.message;
      });
  },
});

export default vendorrecommendationsSlice.reducer;
